<template lang="pug">
UiPage(:title="$t('super_admins.title')")
  template(#actions)
    UiButton(
      @click="addSuperAdmin()"
      icon="UserPlus"
    ) {{ $t("actions.add") }}
  .container
    UiCard
      UiCardSection
        RestTable(
          namespace="super_admins"
          ref="superAdminsTable"
          :headers="headers"
          :fetch-handler="getData"
          embed
        )
          template(#cell:actions="{ item }")
            UiStack(spacing="xs")
              UiStackItem
                UiButton(
                  size="sm"
                  variant="smooth-primary"
                  icon="PencilCreate"
                  @click="editSuperAdmin(item)"
                ) {{ $t("actions.edit") }}
              UiStackItem
                UiButton(
                  size="sm"
                  variant="smooth-danger"
                  icon="Trash"
                  @click="deleteSuperAdmin(item)"
                ) {{ $t("actions.delete") }}

  SuperAdminEditModal(
    ref="SuperAdminEditModal"
    @done="reloadList"
  )
</template>

<script>
import axios from "axios";
import ApiSuperAdmins from "@/api/super_admins.js";
import SuperAdminEditModal from "@/modals/SuperAdmins/edit.vue";

export default {
  components: {
    SuperAdminEditModal,
  },

  data() {
    return {
      headers: [
        {
          key: "id",
          label: "#",
          sortable: true,
          squeeze: true,
        },
        {
          key: "email",
          label: "Email",
          sortable: true,
          width: "40%",
        },
        {
          key: "name",
          label: "Name",
          sortable: true,
        },
        {
          key: "actions",
          label: "",
          squeeze: true,
        },
      ],
    };
  },
  methods: {
    reloadList() {
      this.$refs.superAdminsTable.fetchData();
    },

    getData(params, config) {
      return axios
        .get("/api/v1/super_admins", { params: params, ...config })
        .then((resp) => {
          return {
            items: resp.data.super_admins,
            meta: resp.data.meta,
          };
        });
    },

    addSuperAdmin() {
      this.$refs.SuperAdminEditModal.open(null);
    },

    editSuperAdmin(admin) {
      this.$refs.SuperAdminEditModal.open(admin);
    },

    deleteSuperAdmin(admin) {
      this.$dialogConfirm({
        title: this.$t("actions.remove"),
        description: this.$t("actions.confirm_remove"),
        variant: "danger",
        icon: "account-minus",
        okLabel: this.$t("actions.remove"),
        okVariant: "danger",
        okIcon: "Trash",
        cancelVariant: "smooth-secondary",
      }).then((result) => {
        if (!result) return;
        ApiSuperAdmins.destroy(admin.id).then((resp) => {
          this.reloadList();
        });
      });
    },
  },
};
</script>
